module.exports = {"title":"Arriva Flow-Produkte"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/de/abt-product-overview.json
// module id = q8fk
// module chunks = 1